module.exports = __webpack_public_path__ + "static/imlonely-b855d295888cf2d05212ef665fb7c7da.jpg";